import { CarWirelessIcon } from './CarWirelessIcon';

/**
 * author: Michael Irigoyen
 * id E0C3B158-D502-4354-94AC-994A48BD90FE
 * name car-wireless
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-wireless.svg
 * tags
 * - Automotive 
 */
export const CarAutonomousIcon = CarWirelessIcon;
export default CarAutonomousIcon